import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import {
  backgroundImages,
  blackOverlay,
  contentBox,
} from "./banner.module.scss";

//import { Navbar, Nav, Container } from "react-bootstrap"

import BackgroundImage from "gatsby-background-image";

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      indexImage: file(relativePath: { eq: "images/backgroundImage.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);

  return (
    <div>
      <BackgroundImage
        image={data.indexImage.childImageSharp.gatsbyImageData}
        className={backgroundImages}
        alt="Hero Image"
      >
        <div className={blackOverlay}>
          <div className={contentBox}>
            <h1>IT-Solutions & Consulting</h1>
            <h2>by Johannes Lüftenegger</h2>
          </div>
        </div>
      </BackgroundImage>
    </div>
  );
};

export default Banner;
